module.exports = __webpack_public_path__ + "img/likeFilled.9254fec0.png";